import { useEffect } from 'react'

// Ignore emotion's SSR warning for server side rendering specific css issues
export const useNoSSRWarnings = () => {
    useEffect(() => {
        /* eslint-disable no-console */
        const originalConsoleError = console.error
        console.error = (msg, ...args) =>
            /The pseudo class "[^"]+" is potentially unsafe when doing server-side rendering/g.test(msg) ||
            originalConsoleError(msg, ...args)
        /* eslint-enable no-console */
    }, [])
}
